<template>
  <div class="outterBox">
    <div class="topHeader">
      <div class="row">
        <div class="col-5">
          <span> 예약정보 현황 </span>
        </div>
        <div class="col-7 text-right">
          <span class="itemDesc"> ※ 클릭 후 예약 정보 입력 </span>
        </div>
      </div>
    </div>
    <div class="top">
      <div class="itemContainer">
        <div class="item" v-for="(o, i) in revConfirmList" :key="i">
          <div class="itemHeader" @click="headerClicked(i)">
            <div class="infoGrid">
              <div class="info">
                <div class="infoTitle"><span>팀 정보</span></div>
                <div class="infoData">
                  <span>{{ o.teamIndex }} 팀</span>
                </div>
              </div>
              <div class="info">
                <div class="infoTitle">
                  <span>이용일자</span>
                </div>
                <div class="infoData">
                  <span class="text-nowrap">{{ getDateToShort(o.selectedDate) }}</span>
                </div>
              </div>
              <div class="info">
                <div class="infoTitle">
                  <span>티오프</span>
                </div>
                <div class="infoData">
                  <span v-if="listType !== 'REAL'"> {{ o.selectedTeeOff.detailName }}</span>
                  <span v-if="listType === 'REAL'"> {{ o.selectedRealTeeOff.time | toTime }}</span>
                </div>
              </div>
              <div class="info">
                <div class="infoTitle">
                  <span> 홀 수 </span>
                </div>
                <div class="infoData">
                  <span> 18홀 </span>
                </div>
              </div>
              <div class="info">
                <div class="infoTitle">
                  <span>상세정보</span>
                </div>
                <div class="infoData">
                  <span v-if="isComplete(o.receiptDetail)" class="text-info">입력완료</span>
                  <span v-else class="text-danger"> 입력중 </span>
                </div>
              </div>
            </div>
            <div class="arrow d-flex justify-content-center align-items-center">
              <div>상세보기</div>
              <b-icon icon="chevron-up" v-show="selectedItemIndex === i" class="" font-scale="1" />
              <b-icon icon="chevron-down" v-show="selectedItemIndex !== i" class="" font-scale="1" />
            </div>
          </div>
          <div class="itemDetail">
            <TransitionCollapseHeight v-show="selectedItemIndex === i">
              <ReceiptInputForm :list-type="listType" :revConfirm="o" :hasMultiple="revConfirmList.length > 0" />
            </TransitionCollapseHeight>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiptInputForm from '@/pages/RevReceiptPage/Component/ReceiptInputForm';
import {DateUtil} from '@/util/DateUtil';
import TransitionCollapseHeight from '@/components/TransitionCollapseHeight';
export default {
  name: 'ReceiptDetail',
  components: {ReceiptInputForm, TransitionCollapseHeight},
  props: {
    listType: String,
    revConfirmList: Array,
  },
  filters: {
    toTime: function (a) {
      if (!a) return '';
      let position = 2;
      var output = [a.slice(0, position), ':', a.slice(position)].join('');
      return output;
    },
  },
  data() {
    return {
      selectedItemIndex: -1,
      rentList: [],
    };
  },
  computed: {
    isCompany() {
      let user = this.$store.getters['Auth/selectedMember'];
      // 법인회원 코드 : 006
      return user.memType === '006';
    },
  },
  methods: {
    // Date -> YYYYMMDD
    getDateToShort(date) {
      return DateUtil.getYYYY_MM_DD_WEEK(date);
    },

    headerClicked(i) {
      if (this.selectedItemIndex === i) {
        this.selectedItemIndex = -1;
      } else {
        this.selectedItemIndex = i;
      }
    },
    isComplete(rd) {
      return rd.isCompletedContact(this.isCompany) && rd.isCompletedMember();
    },
  },
};
</script>

<style scoped lang="scss">
.outterBox {
  border: 0px solid #6e6e6e;
}

.top {
  display: flex;
  padding: 1rem;
}

.itemDetail {
  //background-color: #fffeee;
}

.itemHeader {
  cursor: pointer;
  background-color: white;
  border: 1px solid #cccccc;

  &:hover {
    border: 1px solid #af8c5e;
  }
}

.arrow {
  .b-icon {
    vertical-align: middle;
    margin-left: 0.5rem;
  }
  span {
    font-weight: bold;
  }
}

.info {
  .infoTitle {
    font-weight: bold;
  }
}

// ==========================================================
// 데스크톱 (viewport >= 992px)
// ==========================================================
@media (min-width: 992px) {
  .topHeader {
    width: 100%;
    margin: 0 auto;
    padding-top: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    font-weight: bold;
    font-size: 1.3rem;
    .itemDesc {
      font-size: 0.9rem;
      font-weight: 500;
      color: #686868;
    }
  }

  .itemContainer {
    width: 100%;
    margin: 0 auto;

    .item {
      margin-top: 0.2rem;
      margin-bottom: 0.2rem;
    }
  }

  .itemHeader {
    display: flex;
    line-height: 2.5rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .infoGrid {
    display: flex;
    flex: 5;
  }

  .info {
    flex: 1;
    text-align: center;
    line-height: 2.5rem;
    margin-left: 2%;
    margin-right: 2%;
    .infoData {
      font-size: 1rem;
    }
  }

  .arrow {
    display: block;
    flex: 1;
    text-align: center;
    vertical-align: middle;
    line-height: 500%;
    border-left: 1px solid #cccccc;
    .b-icon {
      font-size: 1rem;
    }
  }
}

// ==========================================================
// 모바일 (viewport < 992px)
// ==========================================================
@media (max-width: 991.98px) {
  .topHeader {
    width: 100%;
    margin: 0 auto;
    padding-top: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    font-weight: bold;
    font-size: 1.3rem;
    .itemDesc {
      font-size: 0.9rem;
      font-weight: 500;
      color: #686868;
    }
  }

  .itemContainer {
    width: 100%;
    font-size: 0.8rem;

    .item {
      margin-top: 0rem;
      margin-bottom: 0.5rem;
    }
  }

  .itemHeader {
    text-align: center;
    line-height: 2.5rem;
  }

  .infoGrid {
    display: grid;
    grid-template-columns: 2fr 4fr 2fr 2fr 2fr;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .info {
    padding: 0.2rem;
    text-align: center;
    line-height: 2.5rem;
    .infoData {
      font-size: 0.8rem;
    }
  }

  .arrow {
    border-top: 1px solid #cccccc;
    span {
      margin-right: 0.5rem;
    }
  }
}
</style>
